import { render, staticRenderFns } from "./LikertDialog.vue?vue&type=template&id=07fc7a2d&scoped=true&"
import script from "./LikertDialog.vue?vue&type=script&lang=js&"
export * from "./LikertDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fc7a2d",
  null
  
)

export default component.exports